import { baseApi } from "../api";
import { Category } from "../../pages/Transactions";

export const categoriesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<Category[], boolean>({
      query: (isIncome) => ({
        url: "/categories",
        params: { isIncome },
      }),
      providesTags: ["Category"],
    }),
  }),
});

export const { useGetCategoriesQuery } = categoriesApi;
